import { FlowConsumerOfPatientSchema, FlowLookbackDurationUnit } from 'flow-schema';
import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType } from '../base/baseSchema.js';

const MAX_DOCUMENT_LIMIT = 10;

export const DocumentExtractBlockConfigSchema = z.object({
  patient: FlowConsumerOfPatientSchema({ isRequired: false }),
  titleFilters: z.array(z.string()).default([]),
  typeFilters: z.array(z.string()).default([]),
  documentLimit: z
    .number()
    .positive()
    .int()
    .max(MAX_DOCUMENT_LIMIT, `Document limit cannot exceed ${MAX_DOCUMENT_LIMIT}`),
  lookbackDuration: z.object({
    value: z.number().positive().int(),
    unit: z.enum(FlowLookbackDurationUnit),
  }),
  encounterId: z.string().optional(),
});
export type DocumentExtractBlockConfig = z.infer<typeof DocumentExtractBlockConfigSchema>;

export const DocumentExtractBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.DocumentExtract),
  config: DocumentExtractBlockConfigSchema,
});
export type DocumentExtractBlock = z.infer<typeof DocumentExtractBlockSchema>;
